module.exports = __webpack_public_path__ + "img/icon-close-white.890a4315.svg";